function CopySecondMenuItemsToPrimary( )
{   
    var src       = document.querySelectorAll( ".nav__list--mobile li");
    var dst       = document.querySelector( ".site-header__mobile-nav ul");
    var template  = dst.querySelector( ".sugarPunch").closest( ".slide-nav__item");

   src.forEach( function( li )
   {
         var add  = template.cloneNode( true );
         var link = li.querySelector( "a" );
     
         add.querySelector( "a" ).setAttribute( "href", link.getAttribute( "href" ) );
         if( add.querySelector( "a" ).getAttribute( "href" ) != "/account" )
         {
            add.querySelector( ".sugarPunch" ).innerHTML = link.innerHTML;
            dst.appendChild( add );
         }
   } );
}

function StartupMenuTweak( )
{
    if ( window.location.pathname.toLowerCase( ).startsWith( "/tools/recurring/portal") )
    {
        console.log( "starting custom portal menu tweak");

        window.addEventListener( "load", function( )
        {
          CopySecondMenuItemsToPrimary( );
        } );
    }
}

StartupMenuTweak( );

